export const ALL_PLACES = [
  { value: "42", text: "Bogotá" },
  { value: "43", text: "Cali" },
  { value: "44", text: "Barranquilla" },
  { value: "45", text: "Montería" },
  { value: "46", text: "Cartagena" },
  { value: "47", text: "Santa Marta" },
  { value: "48", text: "San Andrés" },
  { value: "49", text: "Bucaramanga" },
  { value: "50", text: "Cucuta" },
  { value: "51", text: "Apartadó" },
  { value: "52", text: "Bahía Solano" },
  { value: "53", text: "Nuquí" },
  { value: "54", text: "Quibdó" },
  { value: "55", text: "Montelíbano" },
  { value: "57", text: "Armenia" },
  { value: "58", text: "Caucasia" },
  { value: "59", text: "Corozal" },
  { value: "61", text: "El Bagre" },
  { value: "62", text: "Pereira" },
  { value: "63", text: "Tolú" },
  { value: "64", text: "Ibagué" },
  { value: "65", text: "Acandí" },
  { value: "66", text: "Manizales" },
  { value: "103", text: "Medellín" },
  { value: "104", text: "Rionegro" },
  { value: "105", text: "Miami" },
  { value: "106", text: "Fort Lauderdale" },
  { value: "107", text: "Nueva York" },
  { value: "109", text: "Ciudad de México" },
  { value: "110", text: "El Salvador" },
  { value: "111", text: "Lima" },
  { value: "112", text: "Panamá" },
  { value: "114", text: "Madrid" },
  { value: "115", text: "Curazao" },
  { value: "7572", text: "Aruba" },
  { value: "8893", text: "Carepa" },
  { value: "8894", text: "Cancún" },
  { value: "8895", text: "Leticia" },
  { value: "8896", text: "Orlando" },
  { value: "8897", text: "Pasto" },
  { value: "8898", text: "Punta Cana" },
  { value: "8899", text: "Riohacha" },
  { value: "8900", text: "Santiago de Chile" },
  { value: "8901", text: "Valledupar" },
  { value: "8902", text: "Villavicencio" },
  { value: "8903", text: "San José" },
  { value: "8904", text: "Santo Domingo" },
  { value: "8905", text: "La Macarena" },
  { value: "8906", text: "Bajo Baudó" },
  { value: "8907", text: "Condoto" },
  { value: "8908", text: "Juradó" },
  { value: "8909", text: "Urrao" },
  { value: "8910", text: "Puerto Berrío" },
  { value: "8911", text: "San Pedro de Urabá" },
  { value: "8912", text: "Cartago" },
  { value: "8913", text: "Barrancabermeja" },
].sort((a, b) => a.text.localeCompare(b.text))

export const ALL_AIRLINES = [
  { value: "7622", text: "Aeroméxico" },
  { value: "8876", text: "American Airlines" },
  { value: "8877", text: "Avianca" },
  { value: "8878", text: "Copa Airlines" },
  { value: "8879", text: "JetBlue" },
  { value: "8880", text: "Latam Airlines" },
  { value: "8881", text: "Spirit Airlines" },
  { value: "8882", text: "Viva" },
  { value: "8883", text: "Air Europa" },
  { value: "8884", text: "EasyFly" },
  { value: "8885", text: "EZ Air" },
  { value: "8886", text: "Jetair Caribbean" },
  { value: "8887", text: "JetSMART" },
  { value: "8888", text: "Sarpa" },
  { value: "8889", text: "Wingo" },
  { value: "8890", text: "Ultra Air" },
  { value: "8891", text: "Viva Aerobus" },
  { value: "8892", text: "Satena" },
].sort((a, b) => a.text.localeCompare(b.text))

export const ALL_REASONS = [
  { value: "1", text: "Business" },
  { value: "2", text: "Leisure" },
  { value: "3", text: "Family" },
].sort((a, b) => a.text.localeCompare(b.text))

export const ALL_WEATHERS = [
  { value: "5", text: "Despejado" },
  { value: "6", text: "Nublado" },
  { value: "7", text: "Niebla" },
  { value: "8", text: "Lluvia" },
  { value: "9", text: "Llovizna" },
  { value: "10", text: "Techo de nubes bajo" },
].sort((a, b) => a.text.localeCompare(b.text))

export const ALL_FRECUENCY = [
  { value: "15", text: "Primera vez" },
  { value: "16", text: "Frecuentemente (más de una vez al mes)" },
  { value: "17", text: "Rara vez (1 vez en seis meses)" },
  { value: "18", text: "Permanentemente (más de una vez a la semana)" },
].sort((a, b) => a.text.localeCompare(b.text))

export const ALL_AIRPORTS = [
  {
    value: "MDE",
    text: "Aeropuerto Internacional José María Córdova, Rionegro",
  },
  { value: "EOH", text: "Aeropuerto Olaya Herrera, Medellín" },
  { value: "MTR", text: "Aeropuerto Los Garzones, Montería" },
  { value: "APO", text: "Aeropuerto Antonio Roldán Betancur, Carepa" },
  { value: "CZU", text: "Aeropuerto Las Brujas, Corozal" },
  { value: "UIB", text: "Aeropuerto El Caraño, Quibdó" },
  // { value: "ALL", text: "Administración general - Airplan" },
].sort((a, b) => a.text.localeCompare(b.text))

export const UIB_DEPENDENCIES = [
  { value: "UIB", text: "Aeropuerto" },
  { value: "CC_UIB", text: "Centro Comercial" },
  { value: "BIBL_UIB", text: "Biblioteca Pública" },
].sort((a, b) => a.text.localeCompare(b.text))

export const ALL_VISIBILITIES = [
  { value: "11", text: "Buena" },
  { value: "24", text: "Media" },
  { value: "25", text: "Baja" },
].sort((a, b) => a.text.localeCompare(b.text))

export const ALL_SURFACES = [
  { value: "11", text: "Seca" },
  { value: "24", text: "Húmeda" },
  { value: "25", text: "Con barro" },
].sort((a, b) => a.text.localeCompare(b.text))

export const EMAIL_FORMS_RECIPERS = {
  MDE: ["sauskrg@airplan.aero", "aperez@airplan.aero"],
  EOH: ["sauskmd@airplan.aero", "aperez@airplan.aero"],
  MTR: ["sauskmr@airplan.aero", "aperez@airplan.aero"],
  APO: ["secretariasklc@airplan.aero", "aperez@airplan.aero"],
  CZU: ["secretariaskcz@airplan.aero", "aperez@airplan.aero"],
  UIB: ["secretariaskui@airplan.aero", "aperez@airplan.aero"],
  CC_UIB: ["secretariaskui@airplan.aero", "aperez@airplan.aero"], //centro comercial
  BIBL_UIB: ["secretariaskui@airplan.aero", "aperez@airplan.aero"],//biblioteca
  ALL: ["recepcion@airplan.aero", "aperez@airplan.aero"],
}

// export const EMAIL_FORMS_RECIPERS = {
//   MDE: ["ovelez@airplan.aero"],
//   EOH: ["ovelez@airplan.aero"],
//   MTR: ["ovelez@airplan.aero"],
//   APO: ["ovelez@airplan.aero"],
//   CZU: ["ovelez@airplan.aero"],
//   UIB: ["ovelez@airplan.aero"],
//   ALL: ["ovelez@airplan.aero"],
// }

export const SITE_DOMAINS = [
  { domain: "airplan.aero", uid: "ALL" },
  { domain: "aeropuertorionegro.co", uid: "MDE" },
  { domain: "aeropuertomedellin.co", uid: "EOH" },
  { domain: "aeropuertomonteria.co", uid: "MTR" },
  { domain: "aeropuertocarepa.co", uid: "APO" },
  { domain: "aeropuertocorozal.co", uid: "CZU" },
  { domain: "aeropuertoquibdo.co", uid: "UIB" },
]

export const ALL_STOREFONT_CATEGORY = [
  "Alimentos y bebidas",
  "Alquiler de autos",
  "Bancos y casas de cambio",
  "Salas VIP",
  "Venta al detalle",
  "Agencias de viajes",
].sort()

export const EMAIL_TO = []
